module.exports = __webpack_public_path__ + "static/img/5-1-1.685a865c.png";